<template>
  <div class="flex items-center">
    <!-- <div
      v-if="this.$route.query.taction == 'GongcSafeLiabilityInsure' ||this.$route.query.taction == 'GongcTenderbidInsure' || this.$route.query.taction == 'PurchaseTenderbidInsure' || type == 'PurchaseTenderbidInsure' || type == 'GongcTenderbidInsure'"
      class="step w-1024 aui-default pl-[20] pl-[20] pl-[20] pl-[20] aui-bg-white flex aui-row-between"> -->
    <div class="step w-[1024] p-[20] bg-[#fff] flex-center " :class="{ '!w-[100%]': row }">
      <div class="flex">
        <div v-for="(item, i) in stepList[typeKey]" :key="i">
          <div class="flex  items-center" :class="{ 'is-active': Number(activeNum) == i + 1 }">
            <p class="step-index mr-[10]" :class="{ active: Number(activeNum) >= i + 1 }">
              <i v-if="Number(activeNum) > i + 1" class="el-icon-check"></i><span v-else>{{ i + 1 }}</span>
            </p>
            <p class="step-title leading-[20]" :class="{ active: Number(activeNum) >= i + 1 }">{{ item.name }}</p>
          </div>
          <div v-if="i + 1 < stepList[typeKey].length" class="pl-[16] pr-[16]"><i class="icon icon-left">&#xe646;</i>
          </div>
        </div>
      </div>
      <div class="flex justify-self-end" v-if="$route.query.tradeNo">
        <div class="leading-[20] w-[56] tit mr-[8] t-[14] t-[#606266]">订单号</div>
        <div class="leading-[20] t-[#606266]">{{ $route.query.tradeNo }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dg-step",
  props: {
    row: {
      type: Boolean,
      default: false
    },
    active: {
      type: [String, Number],
      default: 1,
    },
    type: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      activeNum: 1,
      typeKey: "",
      stepList: {
        //供应链
        financing: [{ name: "完善材料" }, { name: "选机构填额度" }, { name: "应收账款转让" }, { name: "签章融资文件" }, { name: "收款" }],
        GongcTenderbidInsure: [{ name: "选项目" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //政采投标保函
        PurchaseTenderbidInsure: [{ name: "选项目" }, { name: "选机构" }, { name: "确认" }, { name: "在线签章" }, { name: "支付" }],
        //政采合同履约
        PurchaseContractInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //工程合同履约
        GongcContractInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //农名工工资保函
        GongcNongmgInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //工程质量保函
        GongcQualityInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //法院诉讼
        CourtLowsuitInsure: [{ name: "填信息" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        // 安责险
        GongcSafeLiabilityInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
      },
      showRefine: {
        GongcTenderbidInsure: false, //工程投标保函
        GongcSafeLiabilityInsure: true, // 安责险
        PurchaseTenderbidInsure: false, //政采投标保函
        CourtLowsuitInsure: false, //法院诉讼
        PurchaseContractInsure: true, //政采合同履约
        GongcContractInsure: true, //工程合同履约
        GongcNongmgInsure: true, ///农名工工资保函
        GongcQualityInsure: true, //工程质量保函
        financing: true, //工程质量保函
      },
    };
  },
  methods: {},
  mounted() { },
  created() {
    this.$nextTick(() => {
      if (this.$route.query && this.$route.query.taction) {
        this.typeKey = this.$route.query.taction;
      } else {
        this.typeKey = this.type;
      }

      if (Number(this.active) > 1) {
        this.activeNum = this.showRefine[this.typeKey] ? this.active : Number(this.active) - 1;
      }
    });
  },
};
</script>
<style lang="less" scoped>
@import '~@/assets/css/var.less';
.step {
  flex-shrink: 0;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px -4px rgba(0, 0, 0, 0.12), 0px 4px 4px -2px rgba(0, 0, 0, 0.05), inset 0px -2px 0px 0px rgba(0, 0, 0, 0.08);

  .tit {
    background: #fafafa;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #e4e7ed;
    text-align: center;
  }
}

.icon-left {
  color: #cfcdcd;
  zoom: 0.8;
}

.step-index {
  width: 20px;
  background-color: #f0f2f5;
  text-align: center;
  line-height: 20px;
  color: #909399;
  border-radius: 50%;
  font-size: 12px;

  &.active {
    background-color: @theme;
    color: #ffffff;
  }
}

.step-title {
  color: #909399;

  &.active {
    color: #303133;
  }
}

.is-active {
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: @theme;
  }
}
</style>
 <style>.pl-\[20\] {
    padding-left: 20px
}
.w-\[1024\] {
    width: 1024px
}
.p-\[20\] {
    padding: 20px
}
.bg-\[\#fff\] {
    background-color: #fff
}
.\!w-\[100\%\] {
    width: 100% !important
}
.mr-\[10\] {
    margin-right: 10px
}
.leading-\[20\] {
    line-height: 20px
}
.pl-\[16\] {
    padding-left: 16px
}
.pr-\[16\] {
    padding-right: 16px
}
.w-\[56\] {
    width: 56px
}
.mr-\[8\] {
    margin-right: 8px
}
.t-\[14\] {
    font-size: 14px
}
.t-\[\#606266\] {
    color: #606266
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center
}
.justify-self-end {
    justify-self: flex-end
}</style>